import { hookstate } from "@hookstate/core";

export type FeedMode = "mixed" | "comics";

const STORAGE_KEY = "gc.feed.mode";

function readInitial(): FeedMode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "comics" || stored === "mixed") {
      return stored;
    }
  } catch {
    // localStorage may throw in private mode / SSR — fall through to default.
  }
  return "mixed";
}

export const feedModeStore = hookstate<FeedMode>(readInitial());

export function setFeedMode(mode: FeedMode): void {
  feedModeStore.set(mode);
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Persist failures don't matter — the in-memory state is still correct.
  }
}
